import { gql } from '@apollo/client/core';
import { reactive, toRefs } from '@vue/composition-api';
import { executeQuery } from '@/components/commons/utils.js';

const SIMILAR_PRODUCTS_QUERY = gql`
query similar($taxonomyAttributes:[ID], $taxonomyCategories:[ID], $excludedProducts:[ID], $page:Int) {
  similarProducts(taxonomyAttributes: $taxonomyAttributes, taxonomyCategories: $taxonomyCategories, excludedProducts: $excludedProducts, page: $page) {
    products {
      hashKey
      skuNo
      slug
      title
      onSale
      onClearance
      price {
        currencyCode
        sale
        price
        retail
        clearance
      }
      imageUrl
    }
  }
}
`;

export default function useSimilarProducts() {
  const state = reactive({
    products: [],
    loading: false
  });

  async function load({ taxonomyCategories = [], taxonomyAttributes = [], excludedProducts = [] }) {
    state.products = [];
    state.loading = true;
    const result = await executeQuery(SIMILAR_PRODUCTS_QUERY, {
      taxonomyAttributes,
      taxonomyCategories,
      excludedProducts,
      page: 0
    });

    if(result && result.similarProducts) {
      state.products = result.similarProducts.products;
    }
    state.loading = false;
  }

  return {
    ...toRefs(state),
    load
  };
}
